import React, { createContext, useState } from "react";

interface Props {
  children: React.ReactNode;
}

interface TotalDependentContextValue {
  totalDependent: number;
  setTotalDependent: (value: number) => boolean;
}

// Create the context
const TotalDependentContext = createContext<
  TotalDependentContextValue | undefined
>(undefined);

// Create the context provider component
const TotalDependentContextProvider: React.FC<Props> = ({ children }) => {
  const [totalDependent, setTotalDependentValue] = useState(0);

  const setTotalDependent = (value: number) => {
    setTotalDependentValue(value);
    return true;
  };

  // Define the context value
  const contextValue: TotalDependentContextValue = {
    setTotalDependent,
    totalDependent,
  };

  return (
    <TotalDependentContext.Provider value={contextValue}>
      {children}
    </TotalDependentContext.Provider>
  );
};

export { TotalDependentContext, TotalDependentContextProvider };
